import { WORKFLOW_VARIABLE_LABELS } from "./workflowVariables.constants";

/**
 * Maps `variableId` on a project / form chip to an admin custom variable row for display.
 * @author Muskan Thakur
 */

export const getAdminVariableIdLookupKey = (variableId) => {

  if (variableId == null || variableId === "") return "";

  if (typeof variableId === "object") {
    if (variableId._id != null) return String(variableId._id);
    if (variableId.id != null) return String(variableId.id);
    return "";

  }

  return String(variableId);

};

/**
 * `getCompanyFunctionalArea` type param: from chip row or resolved via `variableId` on admin presets.
 */
export const resolveAdminFunctionalAreaType = (chipOrVariable, adminPresetRows) => {
  const direct = chipOrVariable?.adminCustomVariables;
  if (direct != null && direct !== "") return direct;

  const rows = Array.isArray(adminPresetRows) ? adminPresetRows : [];
  const idKey = getAdminVariableIdLookupKey(chipOrVariable?.variableId);
  if (!idKey || !rows.length) return null;

  const found = rows.find((p) => {
    const keys = [p?._id, p?.id, p?.variableId, p?.adminVariableId].filter((x) => x != null && x !== "").map(String);
    return keys.some((k) => k === idKey);
  });

  const fromRow = found?.adminCustomVariables;
  if (fromRow != null && fromRow !== "") return fromRow;
  return null;
};

export const resolveAdminLinkedVariableLabel = (variableId, adminCustomVariables) => {

  if (variableId == null || variableId === "") return "";

  if (typeof variableId === "object") {
    const fromFields = String(variableId.variableName ?? variableId.name ?? variableId.label ?? "").trim();
    if (fromFields) return fromFields;

  }

  const idKey = getAdminVariableIdLookupKey(variableId);

  if (!idKey || !Array.isArray(adminCustomVariables) || !adminCustomVariables.length) return "";

  const found = adminCustomVariables.find((p) => {
    const keys = [p?._id, p?.id, p?.variableId, p?.adminVariableId].filter((x) => x != null && x !== "").map(String);
    return keys.some((k) => k === idKey);

  });

  return String(found?.variableName ?? found?.name ?? "").trim();

};

const rowLabel = (row) => String(row?.variableName ?? row?.name ?? "").trim();

/**
 * Display name for an admin-linked chip or variable (team card footer, variable detail header
 */
export const getLinkedAdminPresetLabel = (chipOrVariable, adminPresetRows) => {
  if (chipOrVariable?.adminType !== WORKFLOW_VARIABLE_LABELS.IS_ADMIN_FIELD) return "";

  const rows = Array.isArray(adminPresetRows) ? adminPresetRows : [];

  const fromVariableId = resolveAdminLinkedVariableLabel(chipOrVariable?.variableId, rows);
  if (fromVariableId) return fromVariableId;

  const presetKey = chipOrVariable?.adminCustomVariables;
  if (presetKey != null && presetKey !== "") {
    const row = rows.find((r) => r?.adminCustomVariables === presetKey);
    return rowLabel(row);
  }

  const chipName = rowLabel(chipOrVariable);
  if (!chipName) return "";
  const builtin = rows.find((r) => r?.adminCustomVariables == null && rowLabel(r) === chipName);
  return rowLabel(builtin);
};

